import React, { Component } from "react";
import { indexBy, prop } from "ramda";
import htmlToReact from "html-react-parser";
import { TransitionGroup, CSSTransition } from "react-transition-group";
import Modal from "./Modal";

const Page = ({ page, nextPage, previousPage }) => (
  <React.Fragment>
    <div className="portfolio-navigation">
      <div
        onClick={() => !page.first && previousPage()}
        className={page.first ? "back disabled" : "back"}
      />
      <div
        onClick={() => !page.last && nextPage()}
        className={page.last ? "next disabled" : "next"}
      />
    </div>
    <div
      className="image-area"
      style={{
        backgroundImage: `url(img/${page.imgName
        })`
      }}
    />

    <div className="description-area">
      <div className="modal-header" />
      <p className="portfolio-title">{htmlToReact(page.title)}</p>
      <div className="portfolio-description">
        {page.description ? htmlToReact(page.description) : ""}
      </div>
    </div>
  </React.Fragment>
);

class LatestProject extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPageIdx: 0
    };
  }


  handleKeyPress = (event) => {
    if (event.key === "ArrowRight") {
      this.nextPage();
    } else if (event.key === "ArrowLeft") {
      this.previousPage();
    }
  }

  nextPage = () => {
    this.setState({
      currentPageIdx: Math.min(
        this.state.currentPageIdx + 1,
        this.props.latestProject.pages.length - 1
      )
    });
  };

  previousPage = () => {
    this.setState({
      currentPageIdx: Math.max(this.state.currentPageIdx - 1, 0)
    });
  };

  render() {
    const { latestProject, openModal } = this.props;
    const { currentPageIdx } = this.state;
    return (
      <React.Fragment>
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-6">
              <img
                className="img-responsive"
                src={`/img/digital/${latestProject.coverimage}`}
                alt={latestProject.altText}
              />
            </div>
            <div className="col-md-6">
              <h2>Latest Project: {latestProject.title}</h2>
              <div>{htmlToReact(latestProject.description)}</div>
              <button
                className="entry"
                className="btn btn-default btn-block"
                data-toggle="modal"
                data-target="#project"
                onClick={openModal}
              >
                Process And Design
              </button>
            </div>
          </div>
        </div>
        <Modal id="project" handleKeyPress={this.handleKeyPress}>
          <Page
            page={latestProject.pages[currentPageIdx]}
            nextPage={this.nextPage}
            previousPage={this.previousPage}
          />
        </Modal>
      </React.Fragment>
    );
  }
}

export default LatestProject;



// WEBPACK FOOTER //
// ./src/components/latestproject.js